import gql from 'graphql-tag';

import { gql as gqlFn } from '@/graphql/__generated__';

export const ownUserQuery = gqlFn(/* GraphQL */ `
  query ownUser {
    ownUser {
      ...User
    }
  }
`);

export const registerUserMutation = gqlFn(/* GraphQL */ `
  mutation RegisterUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      user {
        id
      }
    }
  }
`);

export const updateUserMutation = gqlFn(/* GraphQL */ `
  mutation UpdateUser(
    $firstName: String!
    $lastName: String!
    $mobileNumber: String
    $image: Upload
    $languageCode: String!
  ) {
    updateUser(
      input: {
        firstName: $firstName
        lastName: $lastName
        mobileNumber: $mobileNumber
        image: $image
        languageCode: $languageCode
      }
    ) {
      user {
        ...User
      }
    }
  }
`);

export const userFragment = gql`
  fragment User on UserNode {
    id
    email
    firstName
    lastName
    languageCode
    mobileNumber
    isActive
    createdAt
    profilePicture {
      ...UserProfilePicture
    }
  }
`;

const userSimpleFragment = gql`
  fragment UserSimple on UserNode {
    id
    email
    firstName
    lastName
  }
`;
